import React from 'react';

export default function NotFoundPage() {
  return (
    <div>
      <h1>404 Not Found</h1>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/views/NotFoundPage.jsx
 **/